import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorFallback from '../../static-pages/500_NoBtn';
import './App.css';

const Main = lazy(() => import('./components/main/Main'));
const ViewForum = lazy(() => import('./components/main/ViewForum'));
const ViewTopic = lazy(() => import('./components/main/ViewTopic'));

function App() {
  return (
    <Suspense fallback="">
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/:id" element={<ViewForum />} />
        <Route path="/:id/:topic?" element={<ViewTopic />} />
        <Route path="/:id/:topic?/:page?" element={<ViewTopic />} />
        <Route path="*" element={<ErrorFallback />} />
      </Routes>
    </Suspense>
  );
}

export default App;
